import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserSideBar from "./User/userSideBar";
import userb from "./User/UserImage/darkBlue.jpg";

const UserPage = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const accessToken = params.get("token");
        const usernameParam = params.get("username");

        if (accessToken) {
            localStorage.setItem("access_token", accessToken);
            if (usernameParam) {
                localStorage.setItem("username", usernameParam);
                setUsername(usernameParam);
            }
            window.history.replaceState({}, document.title, "/user");
        } 
        // Else if we don't have a token stored, redirect to login
        else if (!localStorage.getItem("access_token")) {
            alert("You are not logged in. Redirecting to login...");
            navigate("/");
        } 
        // Otherwise, fetch the username from localStorage
        else {
            setUsername(localStorage.getItem("username") || "User");
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("username");
        alert("You have been logged out.");
        navigate("/");
    };

    const handleBack = () => {
        navigate("/");
    };

    const goToWeatherQuery = () => {
        navigate("/weather");
    };

    const goToTechNews = () => {
        navigate("/news");
    };

    const goToLeetcodeNotes = () => {
        navigate("/leetcode");
    };

    const goToMovieSharing = () => {
        navigate("/movies");
    };

    return (
        <div 
            className="min-h-screen flex bg-gray-100 dark:bg-gray-900 items-center"
            style={{ 
                backgroundImage: `url(${userb})`, 
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}
            >
            <UserSideBar />
            <div className="flex-grow flex flex-col items-center p-8">
                <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                    Welcome, {username}!
                </h1>
                <p className="text-gray-700 dark:text-gray-300 mb-8">
                    This is your user dashboard.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 w-full max-w-4xl">
                    {/* Weather Query Card */}
                    <div className="bg-white dark:bg-gray-800 rounded-md shadow p-6 flex flex-col">
                        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-2">
                            Weather Query
                        </h2>
                        <p className="text-gray-600 dark:text-gray-400 flex-grow">
                            Check the current weather anywhere in the world.
                        </p>
                        <button
                            onClick={goToWeatherQuery}
                            className="mt-4 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300"
                        >
                            Go to Weather
                        </button>
                    </div>

                    {/* Tech News Card */}
                    <div className="bg-white dark:bg-gray-800 rounded-md shadow p-6 flex flex-col">
                        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-2">
                            Tech News
                        </h2>
                        <p className="text-gray-600 dark:text-gray-400 flex-grow">
                            Stay updated with the latest technology trends.
                        </p>
                        <button
                            onClick={goToTechNews}
                            className="mt-4 bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-4 focus:ring-green-300"
                        >
                            Go to Tech News
                        </button>
                    </div>

                    {/* Leetcode Notes Card */}
                    <div className="bg-white dark:bg-gray-800 rounded-md shadow p-6 flex flex-col">
                        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-2">
                            Leetcode Notes
                        </h2>
                        <p className="text-gray-600 dark:text-gray-400 flex-grow">
                            Organize your algorithm solutions and track your progress.
                        </p>
                        <button
                            onClick={goToLeetcodeNotes}
                            className="mt-4 bg-purple-600 text-white py-2 px-4 rounded-md hover:bg-purple-700 focus:outline-none focus:ring-4 focus:ring-purple-300"
                        >
                            Go to Notes
                        </button>
                    </div>

                    {/* Movie Sharing Card */}
                    <div className="bg-white dark:bg-gray-800 rounded-md shadow p-6 flex flex-col">
                        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-2">
                            Movie Sharing
                        </h2>
                        <p className="text-gray-600 dark:text-gray-400 flex-grow">
                            Share and discuss your favorite movies with others.
                        </p>
                        <button
                            onClick={goToMovieSharing}
                            className="mt-4 bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300"
                        >
                            Go to Movies
                        </button>
                    </div>
                </div>

                <div className="mt-10 flex space-x-4">
                    <button
                        onClick={handleLogout}
                        className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300"
                    >
                        Logout
                    </button>
                    <button
                        onClick={handleBack}
                        className="bg-gray-600 text-white px-6 py-2 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-300"
                    >
                        Back to Homepage
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserPage;
